export const contentMaxWidth = "1140px";
